const { locale } = window;

try {
    require(`flatpickr/dist/l10n/${locale}.js`).default;
} catch (e) {
    // Ugly hax to get current flatpickr locale
}

flatpickr.defaultConfig = {
    ...flatpickr.defaultConfig,
    time_24hr: true,
    dateFormat: 'Y-m-d H:i',
    enableTime: true,
    allowInput: true,
    minuteIncrement: 1,
    locale,
};

window.SmoothcompLib = {
    dropdown(queryOrElems, options) {
        const opts = $.extend({
            fullTextSearch: 'exact',
            duration: 70
        }, options);
        return $(queryOrElems).dropdown(opts);
    },

    flatpickr(query) {
        return $(query).flatpickr({
            // Should be imported from flatpickrFunctions
            onClose(d) {
                if(this.config.allowInput && this.altInput) {
                    const newValue = this.parseDate(this.altInput.value, this.config.altFormat);
                    if(!d[0] && !newValue) return;
                    if(!d[0] !== !newValue || (newValue.getTime() !== d[0].getTime())) {
                        this.setDate(this.altInput.value, true)
                    }
                }
            }
        });
    },

    displayFilename(e, displaySelector) {
        // Event listener for <input type=file> 'change' event.
        // Will show the filename in element specified by displaySelector
        const filename = e.target.value.split('\\').pop();
        $(displaySelector).text(filename);
        return true;
    },

    showImageEditModal(event, strName) {
        const strModalContainer = `.g-modal-image-edit-${strName}`;
        const strImagePreviewEl = `#g_image_preview_${strName}`;
        // const strHidEl = `#g_image_options_${strName}`;
        /* const domImageOptions = $(strHidEl).val();
        let strFilename; */
        const opts = {
            width: 845,
            height: 315,
            eventOnChange: 'guillotinechange',
        }

        switch(strName) {
            default:
            case 'cover':
            case 'background':
                opts.width = 845;
                opts.height = 315;
                break;
            case 'profile':
                opts.width = 200;
                opts.height = 200;
                break;
            case 'page_cover':
                opts.width = 1350;
                opts.height = 400;
                break;
            case 'news_cover':
                opts.width = 750;
                opts.height = 400;
                break;
        }

        const domImagePreview = $(strImagePreviewEl);

        domImagePreview.on('load', () => {
            domImagePreview.guillotine(opts);
            domImagePreview.guillotine('fit');
            domImagePreview.on('guillotinechange', (_e, data) => {
                $(`input[name="${strName}_image_options[scale]"]`).val(data.scale);
                $(`input[name="${strName}_image_options[x]"]`).val(data.x);
                $(`input[name="${strName}_image_options[y]"]`).val(data.y);
                $(`input[name="${strName}_image_options[h]"]`).val(data.h);
                $(`input[name="${strName}_image_options[w]"]`).val(data.w);
            });

            const data = domImagePreview.guillotine('getData');
            $(`input[name="${strName}_image_options[scale]"]`).val(data.scale);
            $(`input[name="${strName}_image_options[x]"]`).val(data.x);
            $(`input[name="${strName}_image_options[y]"]`).val(data.y);
            $(`input[name="${strName}_image_options[h]"]`).val(data.h);
            $(`input[name="${strName}_image_options[w]"]`).val(data.w);
        });

        if (event) {
            // edit new image
            this.displayFilename(event, `#${strName}_filename`);
            const tgt = event.target || window.event.srcElement;
            const { files } = tgt;

            if (FileReader && files && files.length) {
                const fr = new FileReader();

                fr.onload = () => {
                    domImagePreview.attr('src', fr.result);
                }

                fr.readAsDataURL(files[0]);
            }
        } else {
            // edit existing image
            const strExistingImageUrl = $(`#g_image_url_${strName}`).val();
            domImagePreview.attr('src', strExistingImageUrl);
        }

        $(`${strModalContainer} .picture-action`).on('click', (e) => {
            e.preventDefault();
            domImagePreview.guillotine($(this).data('action'))
        });


        $(strModalContainer).modal({
            backdrop: 'static'
        });

        $(`${strModalContainer} .picture-save`).on('click', (e) => {
            e.preventDefault();
            $(strModalContainer).modal('hide');
        });

        $(`${strModalContainer} .picture-cancel`).on('click', (e) => {
            e.preventDefault();
            $(strModalContainer).modal('hide');
            $(`input[name="${strName}_image_options[scale]"]`).val('');
            $(`input[name="${strName}_image_options[x]"]`).val('');
            $(`input[name="${strName}_image_options[y]"]`).val('');
            $(`input[name="${strName}_image_options[h]"]`).val('');
            $(`input[name="${strName}_image_options[w]"]`).val('');
            $(`input[name="${strName}_image"]`).val('');
            $(`#${strName}_filename`).text('');
        });

        return true;
    }
};
